import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BsEyeFill } from 'react-icons/bs';

function FieldOfficersTable({ fieldOfficers, role, onToggleStatus }) {
  const navigate = useNavigate();

  if (!fieldOfficers || fieldOfficers.length === 0) {
    return (
      <table className="table table-striped text-center">
        <tbody>
          <tr>
            <td colSpan="11">No Entries Found</td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table className="table table-striped text-center table-borderless align-middle">
      <thead className="table-dark">
        <tr>
          <th>S.No.</th>
          <th>Name</th>
          {role === 'SUPPORT' && <th>Partner Name</th>}
          <th>Mobile</th>
          <th>Device ID</th>
          <th>Samples Booked</th>
          <th>Total Farmers</th>
          <th>City</th>
          <th>State</th>
          <th>Reports Generated</th>
          {role === 'SUPPORT' && <th>Status</th>} {/* <-- ADD THIS HEADER */}
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {fieldOfficers.map((fo, index) => (
          <tr key={fo.field_officer_id}>
            <td>{fo.row_number || index + 1}</td>
            <td className="text-capitalize">{fo.name}</td>
            {role === 'SUPPORT' && (
              <td className="text-capitalize">{fo.entity_name || '-'}</td>
            )}
            <td>{fo.mobile_no}</td>
            <td data-label="DEVICE">
              {fo.device_id ? fo.device_id : '-'}
            </td>

            <td data-label="SAMPLES BOOKED">
              {fo.samples_booked !== undefined && fo.samples_booked !== null
                ? fo.samples_booked
                : '-'}
            </td>

            <td data-label="TOTAL FARMERS">
              {fo.total_farmers !== undefined && fo.total_farmers !== null
                ? fo.total_farmers
                : '-'}
            </td>
            <td>{fo.city}</td>
            <td>{fo.state}</td>
            <td data-label="REPORTS GENERATED">
              {fo.reports_generated !== undefined && fo.reports_generated !== null
                ? fo.reports_generated
                : '-'}
            </td>

            {role === 'SUPPORT' && (
              <td>
                <Form.Check 
                  type="switch"
                  id={`status-switch-${fo.field_officer_id}`}
                  checked={fo.status === 'A'}
                  onChange={() => onToggleStatus(fo.field_officer_id)}
                />
              </td>
            )}

            <td>
              <Button
                variant="dark"
                size="sm"
                onClick={() =>
                  navigate(
                    (role === 'PARTNER' || role === 'TEAM_MEMBER')
                      ? `/field-officers/${fo.field_officer_id}`
                      : `/field-officers/${fo.field_officer_id}`
                  )
                }
              >
                <BsEyeFill className="me-2" /> View
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default FieldOfficersTable;